const initialPosition = {
  x: 0,
  y: 0,
};

export { initialPosition };
